import React, { useEffect, useState, useRef } from "react";
import { IoIosInformationCircle } from "react-icons/io";
import { IoTicket } from "react-icons/io5";
import ShowSend from "./showsend";

export default function TranSel({ OnClose, chatData }) {
  const [isVisible, setIsVisible] = useState(false);
  const [selectedSeats, setSelectedSeats] = useState([]);
  const modalRef = useRef(null);
  const [showSend, setShowSend] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsVisible(true), 10);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(OnClose, 300);
  };

  const handleClickOutside = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose();
    }
  };

  const numSeats = parseInt(chatData?.num_seats) || 0;
  const startSeat = parseInt(chatData?.seat_no) || 1;
  const seats = Array.from({ length: numSeats }, (_, i) => startSeat + i);

  const toggleSeat = (seat) => {
    setSelectedSeats((prev) =>
      prev.includes(seat) ? prev.filter((s) => s !== seat) : [...prev, seat]
    );
  };

  return (
    <div
      className={`fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-20 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={handleClickOutside}
    >
      <div
        ref={modalRef}
        className={`w-full border border-gray-300 rounded-t-2xl bg-white shadow-xl transform transition-transform duration-300 ease-in-out ${
          isVisible ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ height: "50%" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mt-2">
          <div className="text-center text-xs font-medium">
            <p>SELECT TICKETS TO TRANSFER</p>
          </div>

          <div className="flex justify-center mt-2 gap-2 px-4 items-center border-t border-b border-gray-700">
            <IoIosInformationCircle size={70} className="text-gray-500 " />
            <p className="leading-none">
              Only transfer tickets to people you know and trust to ensure
              everyone stays safe
            </p>
          </div>

          <div className="flex justify-between mt-4 px-4 items-center text-gray-800">
            <p className="font-semibold">
              Sec {chatData?.section}, Row {chatData?.row}
            </p>
            <div className="flex gap-1  items-center">
              <IoTicket />
              <p className="font-semibold">
                {chatData?.num_seats}{" "}
                {chatData?.num_seats > 1 ? "tickets" : "ticket"}
              </p>
            </div>
          </div>

          {/* select seat design */}
          <div className="flex gap-4 mt-6 px-4">
            {seats.map((seat, index) => {
              const isSelected = selectedSeats.includes(seat);
              return (
                <div
                  key={index}
                  onClick={() => toggleSeat(seat)}
                  className="w-20 rounded-xl cursor-pointer"
                  style={{ boxShadow: "0 .5rem .5rem rgba(0, 0, 0, 0.45)" }}
                >
                  {/* Top Half: Seat Number */}
                  <div className="bg-blue-600 text-white rounded-t-xl text-xs font-bold text-center p-2 truncate">
                    SEAT {chatData?.seat_no === "0" ? "" : seat}
                  </div>

                  {/* Bottom Half: Circle Indicator */}
                  <div className="flex justify-center py-4">
                    <div
                      className={`w-6 h-6 rounded-full border-2 transition-all duration-200 ${
                        isSelected
                          ? "bg-blue-600 border-blue-600"
                          : "border-gray-400"
                      }`}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Bottom Action Bar */}
          <div
            className={`fixed bottom-0 left-0 w-full flex flex-col justify-end h-40 px-5 text-gray-800 transition-opacity duration-200 ${
              selectedSeats.length === 0 ? "opacity-50" : "opacity-100"
            }`}
          >
            <div className="flex pb-6 justify-between">
              <p className="text-sm font-medium">
                {selectedSeats.length} Selected
              </p>
              <p
                onClick={
                  selectedSeats.length > 0 ? () => setShowSend(true) : undefined
                }
                className={`text-sm font-medium text-blue-700 ${
                  selectedSeats.length === 0
                    ? "opacity-50 pointer-events-none"
                    : ""
                }`}
              >
                TRANSFER TO &gt;
              </p>
            </div>
          </div>
        </div>
      </div>

      {showSend && selectedSeats !== null && (
        <ShowSend
          chatData={chatData}
          seatNumber={selectedSeats}
          numSeats={selectedSeats.length}
          OnClose={() => {
            setShowSend(false);
            // setSelectedSeats(null);
          }}
        />
      )}
    </div>
  );
}
